import { SxProps } from '@mui/material'

interface FilterDropdownValueStyles {
  dropdownSelectedValue: SxProps
  dropdownSelectedValueActive: SxProps
  disabled: SxProps
}

export const filterDropdownValueStyles: FilterDropdownValueStyles = {
  dropdownSelectedValue: {
    color: 'utils.gray700',
    typography: 'textXsMedium',
    whiteSpace: 'nowrap',
    '&:hover': {
      color: 'utils.gray900',
    },
  },

  dropdownSelectedValueActive: {
    color: 'text.hyperLink',
    '&:hover': {
      color: 'text.hyperLink',
    },
  },
  disabled: {
    color: 'utils.gray500',
  },
}
